module.exports = __webpack_public_path__ + "static/media/md-image.a0c49aae.svg";